import axiosInstance from "./axiosInstance";

export const sendSlackAlert = (params) => {
  return axiosInstance.post(`slack/sendAlert`, params);
};
